import React from 'react';
import PropTypes from 'prop-types';
import EmailInputComponent from './EmailInputComponent';
import parse from 'html-react-parser';
const HeroSection = ({ heading, subheading, buttonText, buttonBgColor }) => {
  return (
    <div className="relative text-center px-7 py-14 pt-16 md:py-12 lg:py-14 md:px-16 lg:px-36 xl:px-44 2xl:px-60">
      <div className="max-w-7xl mx-auto">
        <h1 className="
          text-[2.5rem] lg:text-[3.25rem] leading-[3.125rem] lg:leading-[3.875rem]
          text-white font-bold mb-6 break-words
        ">
          {typeof(heading) == 'string' ? parse(heading) : heading}
        </h1>
        {subheading && (<p className="font-semibold text-white text-[1.375rem] leading-[1.875rem] mb-7">
          {typeof(subheading) == 'string' ? parse(subheading) : subheading}
        </p>)}
        <EmailInputComponent
          id="1"
          className="w-full lg:w-3/4 lg:mx-auto"
          buttonText={buttonText}
          buttonBgColor={buttonBgColor}
        />
      </div>
    </div>
  );
};

HeroSection.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subheading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonText: PropTypes.string,
  buttonBgColor: PropTypes.string
};

export default HeroSection;
